function NXSecurity({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_4287_3327)">
        <path
          d="M7.35359 13.3836C7.12382 13.4722 6.86929 13.4722 6.63952 13.3836C4.84667 12.6952 3.30479 11.4793 2.21756 9.89622C1.13032 8.31318 0.548888 6.43757 0.550051 4.51713V1.54182C0.550051 1.27879 0.65454 1.02652 0.840533 0.840532C1.02653 0.654539 1.27879 0.550049 1.54182 0.550049H12.4513C12.7143 0.550049 12.9666 0.654539 13.1526 0.840532C13.3386 1.02652 13.4431 1.27879 13.4431 1.54182V4.51713C13.4442 6.43757 12.8628 8.31318 11.7756 9.89622C10.6883 11.4793 9.14645 12.6952 7.35359 13.3836Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 4L6 8.5L4 7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4287_3327">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXSecurity;
